import PropTypes from "prop-types";
import React, {Component} from "react";
import "react-drawer/lib/react-drawer.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logoLightSm from "../../assets/images/logo-sm-light.png";
import {withTranslation} from "react-i18next";
import {headerSioInit} from "../../store/layout/header/actions";
import {isUserAuthenticated} from "../../api/calls/login";
import {getUser} from "../../common/general";
import {notificationDropdownRefresh} from "../../store/layout/notificationDropdown/actions";

class Header extends Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }

  componentDidMount() {
    if (!this.props.sioLive) {
      const {onHeaderSioInit} = this.props;
      onHeaderSioInit();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (!prevProps.sioLive && this.props.sioLive) {
        this.props.sio.emit("join", getUser().user.sio_room);
        this.props.sio.on('notification', (data) => {
          if (isUserAuthenticated()) {
            this.showToast(JSON.parse(data))
          }
        });
        this.props.sio.on('notification-refresh', (data) => {
          if (isUserAuthenticated()) {
            this.props.onNotificationDropdownRefresh({history: this.props.history})
          }
        });
      }
    }
  }

  showToast(notification) {
    toastr.options = {
      positionClass: "toast-top-center",
      progressBar: true,
      newestOnTop: true,
    };
    if (notification.type === 0) toastr.success(notification.message, notification.title);
    else if (notification.type === 1) toastr.info(notification.message, notification.title);
    else if (notification.type === 2) toastr.warning(notification.message, notification.title);
    else if (notification.type === 3) toastr.error(notification.message, notification.title);
    else toastr.error("NOTIFICATION FAILED", "FATAL ERROR");
  }

  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  toggleFullscreen() {
    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box d-lg-none d-md-block">
                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoLightSm} alt="" height="22"/>
                  </span>
                </Link>
              </div>
              <button type="button" onClick={this.toggleMenu} className="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn">
                <i className="fa fa-fw fa-bars"></i>
              </button>
            </div>
            <div className="d-flex">
              <LanguageDropdown/>
              <div className="dropdown d-none d-lg-inline-block ms-1">
                <button type="button" onClick={this.toggleFullscreen} className="btn header-item noti-icon" data-toggle="fullscreen">
                  <i className="bx bx-fullscreen"></i>
                </button>
              </div>
              <NotificationDropdown/>
              <ProfileMenu/>
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  toggleMenuCallback: PropTypes.any,
  onHeaderSioInit: PropTypes.func,
  onNotificationDropdownRefresh: PropTypes.func,
};

const mapStateToProps = ({Header}) => ({
  sio: Header.sio,
  sioLive: Header.sioLive,
});

const mapDispatchToProps = dispatch => ({
  onHeaderSioInit: data => dispatch(headerSioInit(data)),
  onNotificationDropdownRefresh: data => dispatch(notificationDropdownRefresh(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Header));